<div class="custom-select" [ngClass]="{ 'open': isOpen }">
    <div class="selected-option">
        <div class="options-country" (click)="toggleOptions()">
            <img alt="{{ selectedOption?.country }}"
                [defaultImage]="env.S3_STATIC_FILES + '/images/web/gif-load-refresh.svg'"
                [lazyLoad]="selectedOption?.image" width="20px" height="20px">
            <span>{{ selectedOption?.prefix}} <i class="bi bi-caret-down-fill" *ngIf="env.BRAND == 'mcdt'"></i> </span>
        </div>

        <div class="option-input" (click)="isOpen = false">
            <input id="phone-for" type="text" [(ngModel)]="phone_number" directiveOnlyNumbers [placeholder]="selectedOption?.placeholder || '3001234567'"
                class="form-control" inputmode="numeric" [attr.name]="nameInput" [ngClass]="
            {
                'is-invalid': submitted && !validatePhoneNumber(),
                'is-valid' : validatePhoneNumber()
            }" />
        </div>
    </div>

    <div class="invalid-feedback color-error mt-2" [ngClass]="
        {
            'd-block': submitted &&  !validatePhoneNumber(),
            'd-none' : validatePhoneNumber()
        }
    ">
        Algo está mal con tu número, verifícalo
    </div>

    <div class="custom-options" [ngClass]="
    {
        'd-block':  isOpen,
        'd-none': !isOpen
    }
    ">
        <div class="search-countrys">
            <i class="bi bi-search"></i>
            <input type="text" placeholder="Escribe el país" class="form-control" [(ngModel)]="search">
        </div>
        <div class="box-items-countrys">
            <div *ngFor="let option of filterOptions()" (click)="selectOption(option.country)"
                class="item-country-select">
                <img alt="{{ option.country }}" width="40px" height="40px"
                    [defaultImage]="env.S3_STATIC_FILES + '/images/web/gif-load-refresh.svg'" [lazyLoad]="option.image">
                <span class="select-country-options">{{ option.country }}</span>
                <span class="select-prefix-options">{{ option.prefix }}</span>
            </div>
        </div>
    </div>
</div>
